import { render } from "./MarketingSection.vue?vue&type=template&id=95b9df82"
import script from "./MarketingSection.vue?vue&type=script&lang=js"
export * from "./MarketingSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__